(function() {
	'use strict';

	angular
		.module('app.setup')
		.service('importProjectsService', importProjectsService);

	importProjectsService.$inject = ['$http', 'URLS', '$rootScope', 'storeService'];

	function importProjectsService($http, URLS, $rootScope, storeService) {
		var service = {
			importProjects: importProjects,
			getProjectsTemplate: getProjectsTemplate
		};
		return service;

		function importProjects(projects) {
			var fd = new FormData();
			fd.append('file', projects.file);
			var adminConfig = storeService.getState().adminConfig;
			return $http.post('/api/2/factndx/' + adminConfig.factory.id + '/LeanProject/Import', fd, {
				transformRequest: angular.identity,
				headers: {
					'Content-Type': undefined,
					'isFileUpload': true
				}
			}).then(importProjectsSuccess, handleError);

			function importProjectsSuccess(response) {
				return response;
			}
		}

		function handleError (error) {
			return error;
		}

		function getProjectsTemplate() {
			var adminConfig = storeService.getState().adminConfig;
			jQuery.fileDownload(URLS.host + URLS.prefix + adminConfig.factory.id + '/LeanProject/ProjectTemplate', {
				httpMethod: 'GET',
				encodeHTMLEntities: false,
				successCallback: function (url) {},
				failCallback: function (responseHtml, url) {
					$rootScope.$emit('toast', {
						'message': 'Unable to Download Document',
						'success': false
					});
				}
			});
		}
	}
})();
